import AbstractApiModel from '@/models/abstracts/AbstractApiModel';

/** POST /logout {refresh_token} : invalide le refresh token côté API */
export default class LogoutModel extends AbstractApiModel {
  protected _path = '/logout';
}
